// app.po-imports.*.tsx — the "PO Inbox" feature (purchase-order PDF upload
// and parsing → draft order): list (_index), upload (new), and detail ($id).
//
// `shared.tierGateSuffix` intentionally carries a LEADING space (" tier.")
// so it reads naturally directly after the hardcoded, never-translated
// <strong>Pro</strong> tier-name span in JSX — the Italian counterpart has
// no leading space because "Pro" sits immediately before its own punctuation
// in that word order (see it/poImports.ts for the mirrored comment). Do not
// "clean up" that leading space; it's load-bearing for adjacency.
export const poImports = {
  shared: {
    tierGatePrefix: "PO PDF parsing is included in the",
    tierGateSuffix: " tier.",
  },
  list: {
    uploadButton: "Upload a PO",
    emptyBanner:
      "Your PO Inbox is empty. Upload a buyer's purchase-order PDF and the AI turns it into a ready-to-review draft order — no re-keying.",
    historyHeading: "History",
  },
  upload: {
    heading: "Upload a PO",
    upgradeLink: "Upgrade your plan",
    tierRequiredError: "PO upload requires the Pro tier.",
    noFileError: "No file uploaded.",
    notPdfError: "Only PDF files are supported.",
    fileTooLargeError: "PDF too large ({{sizeMb}} MB) — max is {{maxMb}} MB.",
    invalidPdfError: "File doesn't look like a PDF (missing %PDF header).",
    aiNotReady: {
      heading: "AI features pending setup.",
      body: "The PO parser needs Trigger.dev + OpenRouter credentials. Until your operator finishes setup, uploaded POs will sit in PENDING and never be parsed.",
      envVarsPrefix: "(Set",
      envVarsAnd: "and",
      envVarsSuffix: "in the production environment.)",
    },
    openAiAssistantLink: "Open AI Assistant",
    dropHeading: "Drop your purchase order",
    parseButton: "Parse PO",
    helperText: "Supports scanned or photographed PDFs. Lines below 0.7 confidence are flagged for manual review.",
  },
  detail: {
    draftCreatedNotice: "Draft order created.",
    draftCreatedCatalogPriceNotice:
      "Draft order created — but the PO's currency couldn't be determined, so lines were charged at your current catalog price. Verify pricing before invoicing.",
    statusHeading: "Status",
    parseCost: "parse cost ${{cost}}",
    parsingBanner: "We're parsing the PDF — refresh in a few seconds.",
    parsedLinesHeading: "Parsed line items",
    qtyLabel: "qty {{qty}}",
    confidenceLabel: "conf {{pct}}%",
    matchedFallback: "matched",
    unmatchedBadge: "unmatched",
    createSectionHeading: "Create draft order",
    companyLabel: "Company",
    noCompaniesPrefix: "No B2B companies found —",
    noCompaniesLink: "create one here in about 20 seconds",
    noCompaniesSuffix: ", then come back. Or paste a Company GID manually below.",
    companyGidLabel: "Company GID",
    companyGidHelpText: "From Shopify admin → Customers → Companies (the URL contains it).",
    buyerEmailLabel: "Buyer email",
    createDraftOrderButton: "Create draft order",
    draftAlreadyCreatedButton: "Draft order already created",
    errors: {
      alreadyCreated: "Draft order already created for this PO import.",
      pickCompany: "Pick a company first.",
      invalidCompanyGid: "Company ID must be a Shopify GID (gid://shopify/Company/...).",
      invalidBuyerEmail: "A valid buyer email is required to create the draft order.",
      noMatchedLines: "No matched, in-stock lines to create a draft order from.",
      inFlight: "Draft order already in flight for this PO import. Please wait a moment and retry.",
      createFailed: "Couldn't create draft order. Please try again.",
      creationFailedFallback: "Draft order creation failed.",
    },
  },
};
